import { useReducer } from 'react';

export enum CanjeAction {
  CONTINUAR,
  RECIBIR_RESPUESTA_DIRECCIONES,
  ERROR,
  REINICIAR,
  ERROR_OTP,
}

/**
Posibles estados:
 * INICIAL: formulario antes de consultar por un producto
   al backend.
 * ESPERANDO_RESPUESTA_PRODUCTO: se espera la respuesta 
   del backend luego de consultar por un producto.
 * CANJE_PRODUCTO: se realizó la primera parte del canje
   de producto
 * ESPERANDO_RESPUESTA_DIRECCIONES: se espera la respuesta 
   del backend luego de consultar por las direcciones del 
   cliente.
 * FORMULARIO: se espera que el cliente complete el 
   formulario de teléfono y los otros formularios según
   corresponda el caso.
 * OTP: se espera que el usuario complete el formulario
   de otp 
 * ESPERANDO_RESPUESTA_CANJE: se enviaron los datos de 
   formulario y OTP al backend, se espera la respuesta 
   sobre el canje.
 * CANJE_EXITOSO: el canje se completó.
 * ERROR: hubo un error en los casos anteriores.
 * ERROR_OTP_STATUS: hubo error en la etapa de código otp.
 */
export enum CanjeStatus {
  INICIAL,
  ESPERANDO_RESPUESTA_PRODUCTO,
  CANJE_PRODUCTO,
  ESPERANDO_RESPUESTA_DIRECCIONES,
  FORMULARIO,
  OTP,
  ESPERANDO_RESPUESTA_CANJE,
  CANJE_EXITOSO,
  ERROR,
  ERROR_OTP_STATUS,
}

const ERROR_STATUSES = [CanjeStatus.ERROR, CanjeStatus.ERROR_OTP_STATUS];

const LOADING_STATUSES = [
  CanjeStatus.ESPERANDO_RESPUESTA_PRODUCTO,
  CanjeStatus.CANJE_PRODUCTO,
  CanjeStatus.ESPERANDO_RESPUESTA_DIRECCIONES,
  CanjeStatus.ESPERANDO_RESPUESTA_CANJE,
];

const OTP_STATUSES = [CanjeStatus.OTP, CanjeStatus.ERROR_OTP_STATUS];

const canjeStatusReducer = (status: CanjeStatus, action: CanjeAction) => {
  switch (action) {
    case CanjeAction.RECIBIR_RESPUESTA_DIRECCIONES: {
      /** Sólo actualiza si el estado actual es el esperado.*/
      if (status === CanjeStatus.ESPERANDO_RESPUESTA_DIRECCIONES) return status + 1;
      return status;
    }
    case CanjeAction.CONTINUAR: {
      if (status < CanjeStatus.CANJE_EXITOSO) return status + 1;
      else if (status === CanjeStatus.ERROR_OTP_STATUS) return CanjeStatus.ESPERANDO_RESPUESTA_CANJE;

      return CanjeStatus.ERROR;
    }
    case CanjeAction.REINICIAR: {
      return CanjeStatus.INICIAL;
    }
    case CanjeAction.ERROR_OTP: {
      if (status === CanjeStatus.ESPERANDO_RESPUESTA_CANJE) return CanjeStatus.ERROR_OTP_STATUS;

      return CanjeStatus.ERROR;
    }
    case CanjeAction.ERROR:
    default: {
      return CanjeStatus.ERROR;
    }
  }
};

export const useCanjeStatus = () => {
  const [status, dispatch] = useReducer(canjeStatusReducer, CanjeStatus.INICIAL);
  const isLoading = LOADING_STATUSES.includes(status);
  const isError = ERROR_STATUSES.includes(status);
  const isSuccessful = status === CanjeStatus.CANJE_EXITOSO;
  const isCancellable = status >= CanjeStatus.CANJE_PRODUCTO && status <= CanjeStatus.OTP;
  const showOTP = OTP_STATUSES.includes(status);

  return [status, dispatch, isLoading, isError, isSuccessful, isCancellable, showOTP] as const;
};
